module.exports = __webpack_public_path__ + "static/insight2-6c8ee7d6a91e3d48b11305c75a541991.png";